export default __webpack_public_path__ + "static/media/godsOpen.3450a538.jpg";